import React, { Component } from "react";
import { withNavigation } from "../withNavigation";
import "../styles/adminusers.css";
class AdminUsers extends Component {
    constructor(props) {
        super(props);

        this.state = {
            users: [],
            loading: true,
            search: ""
        };
    }

    async componentDidMount() {
        const admin = localStorage.getItem("adminToken");

        if (!admin) {
            this.props.navigate("/admin", { replace: true });
            return;
        }

        try {
            const res = await fetch("https://api.hi-bigame.online/admin/users");

            const data = await res.json();

            this.setState({
                users: data,
                loading: false
            });

        } catch {
            this.setState({
                loading: false
            });
        }
    }


    goBack = () => {
        this.props.navigate("/admin-dashboard");
    };


    addMoney = async (id) => {
        await fetch("https://api.hi-bigame.online/admin/add-money",
            {
                method: "POST",
                headers: {
                    "Content-Type":
                        "application/json"
                },
                body: JSON.stringify({
                    userId: id,
                    amount: 100
                })
            }
        );

        window.location.reload();
    };


    render() {
        return (
            <div>

                <div className="admin-users-container">

                    <h1 className="admin-users-title">👥 Users List</h1>

                    <button className="admin-users-back" onClick={this.goBack}> Back</button>

                    <input type="text" placeholder="Search username..." value={this.state.search} onChange={(e) =>
                        this.setState({ search: e.target.value })} className="admin-users-search" />

                    {this.state.loading ? (<h3 className="loading-text">Loading...</h3>) : (

                        <div className="table-wrapper">

                            <table className="admin-users-table">

                                <thead>
                                    <tr>  <th>ID</th>  <th>Username</th>  <th>Balance</th>  <th>Action</th> </tr>
                                </thead>

                                <tbody>
                                    {this.state.users.filter((u) => u.username
                                                .toLowerCase()
                                                .includes(this.state.search.toLowerCase())
                                        )

                                        .map((u) => (
                                            <tr key={u.id}>
                                                <td>{u.id}</td>  <td>{u.username}</td>   <td>₹{u.balance}</td>
                                                <td>
                                                    <button className="add-money-btn" onClick={() => this.addMoney(u.id)}> 💰 Add ₹100 </button>
                                                </td>
                                            </tr>
                                        ))}
                                </tbody>

                            </table>

                        </div>
                    )}
                </div>

            </div>
        );
    }
}

export default withNavigation(AdminUsers);
